<template>
  <Spinner v-if="sessionStore.isLoading || useAuthStore().isLoading"/>
  <nav class="navbar navbar-dark bg-dark fixed-top">
    <div class="container">
      <a class="navbar-brand" href="#">
        <router-link
          :to="{ name: 'top.page' }"
          class="nav-link text-white"
          :title="$t('LABEL_TOP_PAGE')"
        >
          <img
            :src="baseUrl + '/assets/images/ci/hubsynch_icon.png'"
            class="d-inline-block align-top hubsynch-icon"
          />
        </router-link>
      </a>
      <ul v-if="useAuthStore().isAuth" class="nav justify-content-end">
        <li v-if="routesAvailable['edit.account']" class="nav-item">
          <router-link
            :to="{ name: 'edit.account' }"
            class="nav-link text-white"
            :title="$t('LABEL_EDIT_ACCOUNT')"
          >
            <i class="bi bi-person-fill-gear"></i>
          </router-link>
        </li>


        <li v-if="routesAvailable['credit.cards']" class="nav-item">
          <router-link
            id="nav-credit-card"
            :to="{ name: 'credit.cards' }"
            class="nav-link text-white"
            title="Credit Card"
          >
            <i class="bi bi-credit-card"></i>
          </router-link>
        </li>

        <li v-if="routesAvailable['transaction.history']" class="nav-item">
          <router-link
            id="nav-transaction-history"
            :to="{ name: 'transaction.history' }"
            class="nav-link text-white"
            title="Transaction History"
          >
            <i class="bi bi-book-half"></i>
          </router-link>
        </li>

        <li v-if="routesAvailable['subscriber']" class="nav-item">
          <router-link
              id="nav-subscribers"
              :to="{ name: 'subscriber' }"
              class="nav-link text-white"
              :title="$t('LABEL_SUBSCRIPTIONS')"
          >
            <i class="bi bi-card-checklist"></i>
          </router-link>
        </li>

        <li v-if="routesAvailable['top.page']" class="nav-item">
          <router-link
            id="nav-toppage"
            :to="{ name: 'top.page' }"
            class="nav-link text-white"
            :title="$t('LABEL_TOP_PAGE')"
          >
            <i class="bi bi-house-door-fill"></i>
          </router-link>
        </li>

        <li class="nav-item text-white">
          <a href="#" class="nav-link text-white" :title="$t('LABEL_LOG_OUT')">
            <i
              id="nav-logout"
              v-on:click="logOut()"
              class="bi bi-box-arrow-right"
            ></i>
          </a>
        </li>
      </ul>

      <ul v-else class="nav justify-content-end">
        <li v-if="routesAvailable['login']" class="nav-item">
          <router-link
            :to="{ name: 'login' }"
            class="nav-link text-white"
            exact
          >
            <i class="bi bi-box-arrow-in-right"></i> {{ $t('LABEL_BUTTON_LOGIN') }}
          </router-link>
        </li>

        <li v-if="routesAvailable['registration']" class="nav-item">
          <router-link
            :to="{ name: 'register.agreement' }"
            class="nav-link text-white"
            exact
          >
            <i class="bi bi-person-plus-fill"></i> {{ $t('LABEL_BUTTON_REGISTER') }}
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup>
import { useSessionStore } from "@/stores/sessionStore";
import { useAuthStore } from "@/stores/authStore";
import router from "@/router";
import Spinner from "@/components/Spinner.vue";
import routesAvailable from '@/data/routes.json';

const baseUrl = process.env.VUE_APP_BASE_URL;
const sessionStore = useSessionStore();

async function logOut(){
    if(await sessionStore.logOut()){
        router.push({name: "login"});
    }
    else{
        router.push({name: "error"});
    }
}
</script>